import { BooleanField, Item, TextField } from '../../../types/SitecoreAdapter'

// Copyright Link Adapter
export type CopyrightProps = Item<{
  copyrightLink: null | Item<{
    href: TextField
    text: TextField
    title: TextField
    newWindow: BooleanField
  }>
}>

export const copyrightLinkAdapter = ({
  fields: { copyrightLink },
}: CopyrightProps) => {
  if (!copyrightLink) {
    return null
  }

  return {
    href: copyrightLink.fields.href.value,
    text: copyrightLink.fields.text.value,
    title: copyrightLink.fields.title.value,
    newWindow: copyrightLink.fields.newWindow.value,
  }
}
